import axios from "axios";
import { toast } from "react-toastify";
import jwtDecode from "jwt-decode";

const apiEndpointRefresh = "api/refresh";
const apiThirdPartyEndpointRefresh = "refresh/google";
const accessTokenKey = "token";
const refreshTokenKey = "rtoken";

const authApi = axios.create({baseURL: process.env.REACT_APP_BASE_URL});

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

axios.interceptors.response.use(null, error => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;
  const authorizationError = error.response && 
                              error.response.status === 401;

  // TODO: Avoid retry if there is no refresh token?
  if (authorizationError) {
    setRefreshJwt(getRefreshJwt());
    const issuer = getJwtIssuer();
    const refreshEndpoint = (issuer !== "creaption") ? apiThirdPartyEndpointRefresh : apiEndpointRefresh;

    return authApi.post(refreshEndpoint).then(tokenRefreshResponse => {
      const { access_token } = tokenRefreshResponse.data;
      setJwt(access_token);
      storeJwt(access_token);
      error.config.headers['Authorization'] = "Bearer " + access_token;
      return axios.request(error.config);
    }).catch(refreshError => {
      if (refreshError.response && refreshError.response.status === 401) {
        clearJwt();
        delete error.config.headers['Authorization'];
        return axios.request(error.config);
      }
    });
  }

  if (!expectedError) {
    toast.error("An unexpected error occurrred.");
  }

  return Promise.reject(error);
});

export function setRefreshJwt(jwt) {
  if (jwt) {
    authApi.defaults.headers.common['Authorization'] = "Bearer " + jwt;
  }
}

export function setJwt(jwt) {
  if (jwt) {
    axios.defaults.headers.common['Authorization'] = "Bearer " + jwt;
  }
}

export function clearJwt() {
  delete axios.defaults.headers.common['Authorization'];
}

export function storeJwt(jwt) {
  localStorage.setItem(accessTokenKey, jwt);
}

export function getRefreshJwt() {
  return localStorage.getItem(refreshTokenKey);
}

export function getJwtIssuer() {
  const jwt = localStorage.getItem(accessTokenKey);
  const decoded_token = jwtDecode(jwt);
  const issuer = decoded_token['iss'];

  return issuer;
}

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  patch: axios.patch,
  setJwt
};
